export const isExchangeAsset = (asset) => {
    return (typeof asset === 'object' &&
        asset !== null &&
        !('assetId' in asset || 'baseAsset' in asset) &&
        'symbol' in asset);
};
export const isCombinedAsset = (asset) => typeof asset === 'object' && asset !== null && 'isCombined' in asset && Boolean(asset.isCombined);
export const isTokenAsset = (asset) => typeof asset === 'object' && asset !== null && 'assetId' in asset && Boolean(asset.assetId);
